import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class DeviceManagementRouteDefinition {
  public static getRoutes(
    hasKitchenModuleEnabled: boolean,
    isAllowedToConfigureCFD: boolean
  ): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.DEVICES,
      resolver: AlwaysShowRouteResolver,
      title: 'Devices',
      icon: 'icon-devices.svg',
      position: 7,
      children: [
        {
          path: RoutePaths.OVERVIEW,
          parentPath: RoutePaths.DEVICES,
          title: 'Devices',
          position: 1
        },
        {
          path: RoutePaths.RESTAURANT_SETTINGS,
          parentPath: RoutePaths.DEVICES,
          title: 'Restaurant App Settings',
          position: 2
        }
      ]
    };
    if (hasKitchenModuleEnabled) {
      menuItems.children.push({
        path: RoutePaths.KITCHEN_SETTINGS,
        parentPath: RoutePaths.DEVICES,
        title: 'Kitchen App Settings',
        position: 4
      });
    }
    if (isAllowedToConfigureCFD) {
      menuItems.children.push({
        path: RoutePaths.CFD_SETTINGS,
        parentPath: RoutePaths.DEVICES,
        title: 'CFD App Settings',
        position: 3
      });
    }
    return menuItems;
  }
}
